export enum LanguageTags {
  ru = 'ru',
  en = 'en',
  id = 'id',
}
